import React, { Component } from "react";
import Hero from "./../../components/hero";
import { Colors } from "./../../utils/variables";
import SkillsClinicsSection from "./../../components/skillsClinicsSection";
import skillsClinicsData from "./../../data/skillsClinics.json";

export default class Clinics extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className="light-grey-background" style={{ backgroundColor: Colors.primaryDark }}>
        <div className="slant-bottom">
          <Hero
            title={"Clinics"}
            subtitle={'Optional add-ons to complete your Free To Roam weekend'}
            backgroundImage={"/images/clinics-hero.jpg"}
            height={"threequarter"}
            tint={""}
          />
        </div>
        <div className="primary-background clinics-page--hide-datetime" style={{ backgroundColor: Colors.primaryDark, backgroundImage: 'url("/images/topo-texture.png")' }}>
          <div className="large-padding centered-text" style={{paddingTop:'20vh'}}>
            <SkillsClinicsSection data={skillsClinicsData} variant="cards" showSectionHeader={true} showRegisterButton={false} showImage={false} />
          </div>
        </div>
      </div>
    );
  }
}
